<template>
  <div id="setPassword">

    <mt-header title="设置密码" style="height: 50px">
      <router-link :to="path" slot="left">
        <mt-button>
          <img src="../../../assets/icon/back.png" height="auto" width="8px" slot="icon" style="margin-left: 12px">
        </mt-button>
      </router-link>

    </mt-header>
    <hr style="height: 1px;background-color: #d8d8d8;"/>

    <div class="setPassword-content">
      <div class="setPassword-content-header">
        <img src="" id="setPassword-header-userIcon"/>
        <div class="setPassword-header-phonteNum">{{phonteNum | filterPhone}}</div>
      </div>
      <div class="textfield-view">
        <input type="text"
               style="color:#191919"
               v-model="password"
               placeholder="设置8-20位登录密码"
               class="textfield"/>
        <hr style="height: 1px;background-color: #666666;"/>
      </div>

      <div class="textfield-view">
        <input type="password"
               style="color:#191919"
               v-model="password2"
               placeholder="重复密码"
               class="textfield"/>
        <hr style="height: 1px;background-color: #666666;"/>
      </div>

      <div class="button" @click="login">
        确认
      </div>

      <div class="setPassword-footer">

        <span class="go">设置密码后有助于您在浏览器访问商城时通过手机号登录查看您的账户</span>

      </div>
    </div>


  </div>
</template>

<script>
  //  import { MessageBox } from 'mint-ui'
  import api from '../../../api/mine/api.mine'
  import cookieTools from '../../../js/cookie'
  export default {
    name: 'setPassword',
    mounted () {
    },
    destroyed () {
    },
    computed: {
      phonteNum () {
        return this.$store.state.user.mobilePhone
      },
      path () {
        if (this.$route.query.url.length === 0) {
          return '/mine'
        }
        return this.$route.query.url
      }
    },
    data () {
      return {
        password: '',
        password2: ''
      }
    },
    methods: {
      login () {
        if (this.password.length < 8
          || this.password.length > 20
          || (/^\d*$/.test(this.password))
          || (/^[a-z]*$/i.test(this.password))
          || !(/^[a-z\d]*$/i.test(this.password))) {
          this.utils.alert('密码必须是包含字母和数字的8-20位字符')
          return
        }

        if (this.password !== this.password2) {
          this.utils.alert('密码输入不一致')
          return
        }

        var data = {}
        data.confirmPassword = this.password2
        data.password = this.password
        var self = this
        api.initSetPassword(data,function (successRespond) {
          self.utils.alert('设置密码成功')
          self.$router.push({path: self.path})
        })

      }
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/css/mixin';


  #setPassword-header-userIcon {
    width: pxToRem(140px);
    height: pxToRem(140px);
    background: #EEEEEE;
    -moz-border-radius: pxToRem(70px);
    -webkit-border-radius: pxToRem(70px);
    border-radius: pxToRem(70px);
    border-width: 0px;


    border-color: #000 #000 #000 #000;
  }
  .setPassword-header-phonteNum {
    margin-top: pxToRem(20px);
    margin-bottom: pxToRem(20px);
    font-size: pxToRem(24px);;
  }
  .setPassword-content-header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .setPassword-content {
    margin-top: pxToRem(60px);
  }

  .textfield-view {

    margin-left: pxToRem(52px);
    margin-right: pxToRem(52px);
  }

  .textfield {
    margin-top: pxToRem(60px);
    margin-bottom: pxToRem(30px);
    width: 100%;
  }
  .button {
    background: #3D2D23;
    height: pxToRem(100px);
    line-height: pxToRem(100px);
    text-align: center;
    color: white;
    margin-left: pxToRem(52px);
    margin-right: pxToRem(52px);
    margin-top: pxToRem(80px);
    font-size: pxToRem(28px);
  }
  .setPassword-footer {
    display: flex;
    justify-content: space-between;
    margin-left: pxToRem(52px);
    margin-right: pxToRem(52px);
    margin-top: pxToRem(60px);
    color: #666666;
    font-size: pxToRem(24px);
  }
  .go {
    color: #666666;
  }
</style>


// WEBPACK FOOTER //
// setPassword.vue?e705f6e2